<template>
    <div class="content">
        <div class="table">
            <div class="titHeader">
                <div>序号</div> <div>教材名称</div> <div>单价</div> <div>数量</div> <div>总价</div> <div>操作</div>
            </div>

            <div class="tBody" v-for="(item,index) in $store.state.receiveData" :key="item.id">
                <div>{{ index+1 }}</div> <div>{{item.title}}</div> <div>{{item.price}}</div> <div>{{item.NumBer}}</div> <div>{{item.price*item.NumBer}}</div> <div><a-button icon="close" @click="del(item.id)" style="height:30px;background: #2caf7a;color:#fff;padding-bottom:5px;"></a-button></div>
            </div>

            <div v-if="$store.state.receiveData.length === 0" style="margin-top:10px;text-align:center;color:red;">暂无数据,请从左侧添加！</div>
            <div v-if="$store.state.receiveData.length !== 0" style="padding:20px 0 0 300px;font-weight: 700;font-size:16px;">共计：￥{{getTotal}} </div>
        </div>

       <div class="inputModal">
            <div style="display: flex;margin:0 auto;margin:0 0 0 10px;">
                <div>
                    收货地址：
                    <a-select
                        style="width: 280px;"
                        v-model="address"
                        placeholder="请选择收货地址"
                        allowClear
                        >
                        <a-select-option  v-for="item in addRess" :key="item.id">
                            {{ item.name }}+{{item.phone}}+{{item.detail}}
                        </a-select-option>
                    </a-select>
                </div>
                <div @click="showModal" style="margin-left:10px;width:80px; height:30px;text-align: center;line-height: 30px;color:#ffffff;background: #2caf7a;cursor:pointer;">
                    + 添加地址
                </div>
            </div>

            <div class="remark">
                备注信息：<a-input v-model="remark" placeholder="请输入备注信息" style="width:280px;"></a-input>
            </div>
       </div>

        <div style="margin:50px 0 0 400px;">
            <a-button @click="goBuy" style="background: #2caf7a;color:#fff;">
                去下单
            </a-button>
        </div>

       <!-- 添加收货地址弹窗 -->
        <a-modal
            title="添加地址"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
            >
            <a-form :form="formData">
                <a-form-item label="收货人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入收货人姓名"></a-input>
                </a-form-item>

                <a-form-item label="电话号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['phone', validatorRules.phone]" placeholder="请输入电话号码"></a-input>
                </a-form-item>

                <a-form-item label="详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['detail', validatorRules.detail]" placeholder="请输入详细地址"></a-input>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
export default{
    name:'ListRight',
    components:{
    },

    data:function(){
        return{
            labelCol: {
                xs: { span: 12 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 }
            },
            visible: false,
            confirmLoading: false,
            formData: this.$form.createForm(this),
            validatorRules: {
                name: {
                    rules: [
                    { required: true, message: '请输入专业代码!'},
                    ]
                },
                phone: {
                    rules: [
                    { required: true, message: '请输入专业代码!'},
                    ]
                },
                detail: {
                    rules: [
                    { required: true, message: '请输入专业代码!'},
                    ]
                },
            },
            addRess:[],
            address:'',
            goods:[],
            remark:''
        }
    },

    computed:{
        getTotal(){
            let total = 0;
            this.$store.state.receiveData.map((item,index)=>{
                total += item.price * item.NumBer;
            })
            return total
        }
    },

    created(){
        // 查询我的收货地址列表
        this.getAddress()
    },

    methods:{
        getAddress(){
            this.axios.get(`/biz/material/addr/list`).then(res => {
                if (res.success) {
                    // console.log(res,'addredss')
                    this.addRess = res.result
                }
            })
        },

        del(id){
            this.$store.commit('delReceiveData',id)
        },

        //获取
        showModal() {
            this.visible = true;
        },

        handleOk(e) {
            this.formData.validateFields((err,values)=>{
                if(!err){
                    this.confirmLoading = true;
                    let params = values
                    this.axios.post(`/biz/material/addr/add`,params).then(res => {
                        if (res.code === 200) {
                            this.visible = false;
                            this.confirmLoading = false;
                            this.$message.success(res.message)
                            this.getAddress()
                        }
                    })
                }
            })
        },

        handleCancel(e) {
            console.log('Clicked cancel button');
            this.visible = false;
        },

        goBuy(){
            if(this.address === ''||this.address === undefined){
                this.$message.warning('下单前请选择收货地址！')
            }else{
                console.log(this.address)
                let params={}
                params.addressId = this.address
                this.$store.state.receiveData.forEach(element => {
                    this.goods.push({materialId:element.id,totalNum:element.NumBer})
                });
                params.goods = this.goods
                params.remark = this.remark ? this.remark : ''
                // POST  /biz/material/order/buy
                this.axios.post(`/biz/material/order/buy`,params).then(res => {
                    if (res.code === 200) {
                        console.log(res,'buy')
                        this.address='',
                        this.goods=[]
                        this.remark=''
                        localStorage.setItem('params',JSON.stringify(res.result.param))
                        localStorage.setItem('Url',res.result.url)
                        this.$store.state.receiveData = []
                        this.$emit('ChangeTab')
                        this.$message.success(res.result)
                        this.$emit('getListRight') //下单成功后调一下左侧订购列表
                    }
                })
            }
        }
    },
}
</script>

<style lang="stylus" scoped>
.content{

    .table{
        padding:10px 10px;
        border:1px solid #d9d9d9;

        .titHeader{
            display:flex;
            padding-bottom:20px;
            border-bottom:1px solid #d9d9d9;

             div{
                text-align:center;
            } 

            div:first-child{
                width:30px;
            }
            /*教材名称*/
            div:nth-child(2){
                width:220px;
            }
            /*单价*/
            div:nth-child(3){
                width:50px;
            }
            /*数量*/
            div:nth-child(4){
                width:50px;
            }
            /*总量*/
            div:nth-child(5){
                width:50px;
            }
            /*操作*/
            div:last-child{
                width:80px;
            }
        }

        .tBody{
            
            display:flex;
            line-height:30px;
            margin-top:10px;
            padding-bottom:5px;
            border-bottom:1px dashed #ccc;

            div:first-child{
                width:30px;
                text-align:center;
            }
            /*教材名称*/
            div:nth-child(2){
                width:220px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding-left:10px;
            }
            /*单价*/
            div:nth-child(3){
                width:50px;
                text-align:center;
            }
            /*数量*/
            div:nth-child(4){
                width:50px;
                text-align:center;
            }
            /*总量*/
            div:nth-child(5){
                width:50px;
                text-align:center;
            }
            /*操作*/
            div:last-child{
                width:80px;
                text-align:center;
            }
        }
    }
    
    .inputModal{
        padding:10px;
        margin-top:100px;
        .remark{
            margin:20px 0 0 10px;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/pages/textbookOrder/ListRight.vue